<template>
	<div>
		<div class="container" v-show="type === 'privacy'">
			<div class="header bar">
				<span>개인정보 수집, 이용</span>

				<a href="#" @click.prevent="close">
					<span class="btn-close">
						닫기
					</span>
				</a>
			</div>

			<div class="contents">
				<div class="info-box">
					'파킹클라우드(주)'는 (이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호", "개인정보보호법"에 관한 법률을
					준수하고 있습니다.<br />회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며,
					개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니 다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별 공지)을
					통하여 공지할 것입니다.
				</div>

				<div class="data-box">
					<dl>
						<dt>■ 개인정보 수집·이용 (필수)</dt>
						<dt>1. 수집하는 개인정보의 항목 및 이용 목적, 보유기간</dt>
						<dd>
							<table class="tbl-list">
								<caption>
									수집하는 개인정보의 항목 및 이용 목적, 보유기간
								</caption>
								<colgroup>
									<col width="35%" />
									<col width="*" />
								</colgroup>
								<tbody>
									<tr>
										<th scope="row">수집 항목</th>

										<td>
											- 이름<br />
											- 휴대전화<br />
											- 차량등록증<br />
											- 사업자등록증(법인회원)
										</td>
									</tr>

									<tr>
										<th scope="row">수집 및 이용 목적</th>
										<td>
											차고지 신청 업무 대행
										</td>
									</tr>

									<tr>
										<th scope="row">보유 및 이용기간</th>
										<td>
											① 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											② 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											③ 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											④ 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년 (신용정보의 이용 및 보호에 관한 법률)<br />
											⑤ 서비스 이용 기록, 접속 로그, 접속 IP 정보: 3개월 (통신비밀보호법)<br /><br />
											※ '개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관하여 관리하고 있습니다.
										</td>
									</tr>
								</tbody>
							</table>
						</dd>
					</dl>

					<dl>
						<dt>2. 동의를 거부할 권리 및 동의 거부에 따른 불이익</dt>
						<dd>
							고객님께서 개인정보의 수집, 이용과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있으나, 동의하지 않을 경우 서비스 이용에
							제한됩니다.
						</dd>
					</dl>
				</div>

				<div class="btn-box">
					<a href="#" @click="close">
						<button class="btn big black radius">확인</button>
					</a>
				</div>
			</div>
		</div>

		<div class="container" v-show="type === 'third'">
			<div class="header bar">
				<span>개인정보의 제3자 제공 동의</span>

				<a href="#" @click.prevent="close">
					<span class="btn-close">
						닫기
					</span>
				</a>
			</div>

			<div class="contents">
				<div class="info-box">
					회사는 고객님의 개인정보를 개인정보의 수집ㆍ이용 (필수)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등
					개인정보보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
				</div>

				<div class="data-box">
					<dl>
						<dt>■ 개인정보의 제3자 제공 동의</dt>

						<dt>1. 개인정보 제공받는 자, 제공 목적, 제공 항목, 보유 및 이용기간</dt>

						<dd>
							<table class="tbl-list">
								<caption>
									개인정보 제공받는 자, 제공 목적, 제공 항목, 보유 및 이용기간
								</caption>

								<colgroup>
									<col width="35%" />
									<col width="*" />
								</colgroup>

								<tbody>
									<tr>
										<th scope="row">개인정보 제공받는 자</th>
										<td>
											서비스 이용자의 관할 시 군 구청
										</td>
									</tr>
									<tr>
										<th scope="row">제공 목적</th>
										<td>
											차고지 신청 업무 대행
										</td>
									</tr>
									<tr>
										<th scope="row">제공 항목</th>
										<td>
											- 이름<br />
											- 휴대전화<br />
											- 차량등록증<br />
											- 사업자등록증(법인회원)
										</td>
									</tr>

									<tr>
										<th scope="row">수집 및 이용 목적</th>
										<td>
											차고지 신청 업무 대행
										</td>
									</tr>

									<tr>
										<th scope="row">보유 및 이용기간</th>
										<td>
											① 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											② 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											③ 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)<br />
											④ 신용정보의 수집/처리 및 이용 등에 관한 기록: 3년 (신용정보의 이용 및 보호에 관한 법률)<br />
											⑤ 서비스 이용 기록, 접속 로그, 접속 IP 정보: 3개월 (통신비밀보호법)<br /><br />
											※ '개인정보 유효기간제’에 따라 1년간 서비스를 이용하지 않은 회원의 개인정보를 별도로 분리 보관하여 관리하고 있습니다.
										</td>
									</tr>
								</tbody>
							</table>
						</dd>
					</dl>

					<dl>
						<dt>2. 동의를 거부할 권리 및 동의 거부에 따른 불이익</dt>
						<dd>
							고객님께서 개인정보의 제3자 제공과 관련한 위 사항에 대하여 원하지 않는 경우 동의를 거부할 수 있으나, 동의하지 않을 경우 서비스 이용에
							제한됩니다.
						</dd>
					</dl>
				</div>

				<div class="btn-box">
					<a href="#" @click.prevent="close">
						<button class="btn big black radius">확인</button>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Terms',
	components: {},
	filters: {},
	mixins: [],
	extends: {},
	props: {},
	data() {
		return {
			type: ''
		};
	},
	computed: {},
	watch: {},
	methods: {
		close() {
			return this.$router.go(-1);
		}
	},

	beforeCreate() {},
	created() {
		this.type = this.$route.params.type;
	},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.contents {
	font-size: 0.9em;
	font-weight: 500;
}

.info-box {
	line-height: 150%;
}

dl {
	margin-bottom: 1.6em;

	dt {
		margin-bottom: 0.6em;
		font-weight: 500;
		color: #141414;
	}

	dd {
		line-height: 145%;
		color: #595957;
	}
}
</style>
